import Comp from "./TeamMemberFilters";

export default Comp;
